import React, { useState, useEffect } from 'react';
import Page from 'src/components/Page';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Modal,
  Pagination,
  PaginationItem,
  Paper,
  Radio,
  Snackbar,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import {
  LoadingButton,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineSeparator,
  Timeline
} from '@mui/lab';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import Iconify from 'src/components/Iconify';
import { useLocation, useNavigate } from 'react-router-dom';
import { Table } from '@material-ui/core';
import { api } from 'src/Api';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import { Link as RouterLink } from 'react-router-dom';

export default function History() {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const [loading, setloading] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [pagesCount, setPagesCount] = useState(1);
  const [page, setPage] = useState(1);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [selectedId, setSelectedId] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [trackingData, setTrackingData] = useState([]);
  const [openCommunication, setopenCommunication] = useState(false);
  const [notes, setnotes] = useState('');

  // console.log('🚀 ~ History ~ trackingData:', trackingData);

  useEffect(() => {
    handleGetHistory(1);
  }, []);

  const handleGetHistory = (pages) => {
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    formData.append('status', 'completed');
    // formData.append('page', pages);

    fetch(api.get_service_details, {
      headers: myHeaders,
      body: formData,
      method: 'POST'
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setHistoryData(result.data);
          setPagesCount(Math.ceil(result.count / 10));
        } else {
          console.log('Error:', result.message);
        }
        setloading(false);
      })
      .catch((error) => {
        console.log('Fetch error:', error);
        setloading(false);
      });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    handleGetHistory(value);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleOpenTrackingModal = (id, tracking) => {
    setTrackingData(tracking);
    setSelectedId(id);
    setShowModal(true);
  };

  const handleCloseDocumentList = () => {
    setTrackingData([]);
    setSelectedId('');
    setShowModal(false);
  };

  function openCommunicationModal(id, note) {
    if (note) {
      setnotes(note);
    }
    setSelectedId(id);
    setopenCommunication(true);
  }
  const closeCommunicationModal = () => {
    setSelectedId('');
    setopenCommunication(false);
    setnotes('');
  };

  return (
    <Page title={`Customers | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h4" sx={{ color: '#f90001' }}>
            History
          </Typography>
        </Stack>

        <Modal
          open={showModal}
          onClose={handleCloseDocumentList}
          aria-labelledby="spring-modal-title"
          aria-describedby="spring-modal-description"
          style={{
            display: 'flex',
            height: '100%',
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Box
            sx={{
              width: '60%',
              maxHeight: '90%',
              minHeight: '40%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              padding: 2,
              border: '2px solid',
              borderColor: '#f00001',
              borderRadius: 0.5
            }}
          >
            <Box display={'flex'} justifyContent={'space-between'} pb={1} alignItems={'center'}>
              <Typography
                variant="h6"
                style={{ fontWeight: 'bold', textAlign: 'center', color: '#f90001' }}
              >
                Tracking History
              </Typography>
              <IconButton onClick={handleCloseDocumentList} edge="end">
                <CloseIcon />
              </IconButton>
            </Box>

            <Timeline
              sx={{
                [`& .${timelineItemClasses.root}:before`]: {
                  flex: 0,
                  padding: 0
                }
              }}
            >
              {trackingData.map((val, index) => {
                const isLastIndex = index == trackingData.length - 1;

                return (
                  <TimelineItem
                    sx={{
                      display: 'flex',
                      flexDirection: 'row'
                    }}
                    key={val.id}
                  >
                    <TimelineSeparator>
                      <TimelineDot
                        style={{
                          height: 15,
                          width: 15,
                          marginBottom: 3,
                          borderRadius: 100,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          marginTop: 5,
                          backgroundColor: '#ffffff'
                        }}
                      >
                        <Radio checked={true} size="small" />
                      </TimelineDot>
                      {isLastIndex == 0 && (
                        <TimelineConnector
                          sx={{
                            bgcolor: 'transparent',
                            height: 'auto',
                            width: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            marginRight: 0.3
                          }}
                        >
                          <div
                            style={{
                              height: 50,
                              flex: 1,
                              border: '1.5px dashed #f90001'
                            }}
                          />
                        </TimelineConnector>
                      )}
                    </TimelineSeparator>
                    <TimelineContent
                      style={{ height: 50, marginBottom: 10, paddingTop: 0, paddingLeft: 10 }}
                    >
                      <Typography variant={'body1'} component="span" style={{ fontWeight: 600 }}>
                        {val?.services_aditional_info?.name}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: {
                            xs: '0.55rem',
                            sm: '0.575rem',
                            md: '0.6rem'
                          },
                          lineHeight: { xs: '1.3', sm: '1.3', md: '1.2' },
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          WebkitLineClamp: 2,
                          height: 20
                        }}
                      >
                        {/* {val?.updated_at} */}
                        {moment(val?.updated_at).format('MM-DD-YYYY, h:mm A')}
                      </Typography>
                      {val?.notes ? (
                        <Box
                          sx={{
                            width: '100%',
                            maxWidth: { xs: '500px', sm: '600px', lg: '600px' }
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: {
                                xs: '0.55rem',
                                sm: '0.575rem',
                                md: '0.6rem'
                              },
                              lineHeight: { xs: '1.3', sm: '1.3', md: '1.2' },
                              display: '-webkit-box',
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              WebkitLineClamp: 2,
                              height: 24
                            }}
                          >
                            {val?.notes}
                          </Typography>
                        </Box>
                      ) : (
                        <div style={{ height: 35 }} />
                      )}
                    </TimelineContent>
                    <LoadingButton
                      disabled={!val?.notes}
                      variant="contained"
                      style={{
                        height: 25,
                        fontSize: 10,
                        borderRadius: 5,
                        width: 50,
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingLeft: 9,
                        paddingRight: 9
                      }}
                      onClick={() => openCommunicationModal(val?.id, val?.notes)}
                    >
                      <Iconify icon="material-symbols:add-notes-outline" height={14} width={14} />
                      Notes
                    </LoadingButton>
                  </TimelineItem>
                );
              })}
            </Timeline>
          </Box>
        </Modal>

        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={openCommunication}
          onClose={closeCommunicationModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              maxWidth: '60%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              p: 1,
              border: '2px solid',
              borderColor: 'primary.main',
              flex: 1
            }}
            className="admin_modal_pa"
          >
            <Box
              sx={{
                width: '100%',
                bgcolor: 'background.paper',
                p: 2
              }}
            >
              <Box display={'flex'} justifyContent={'space-between'} pb={1} alignItems="center">
                <Typography
                  variant="h6"
                  style={{ fontWeight: 'bold', textAlign: 'center', color: '#f90001' }}
                >
                  Notes
                </Typography>
                <IconButton onClick={closeCommunicationModal} edge="end">
                  <CloseIcon />
                </IconButton>
              </Box>
              <TextField
                fullWidth
                multiline
                rows={4}
                label="Note"
                variant="outlined"
                name="Note"
                value={notes}
                onChange={(e) => setnotes(e.target.value)}
                disabled={true}
              />
            </Box>
          </Box>
        </Modal>

        <TableContainer
          component={Paper}
          sx={{ boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', mt: 2, mb: 2, minWidth: 800 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Name</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Email</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Contact</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Company</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Service</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#f00001', whiteSpace: 'nowrap' }}>
                  Sub Service
                </TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Completion Date</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#f00001' }}>Action</TableCell>
              </TableRow>
            </TableHead>

            {!loading && historyData?.length !== 0 && (
              <TableBody>
                {historyData?.map((item, index) => (
                  <TableRow>
                    <TableCell scope="row" padding="normal" style={{ width: 150 }}>
                      <Stack direction="row" alignItems="center" spacing={1} style={{ width: 150 }}>
                        <Box style={{ display: 'flex', flexDirection: 'column', width: 120 }}>
                          <Typography variant="subtitle2" flexWrap={'wrap'}>
                            {item.customer_name === 'undefined' ? 'N/A' : item.customer_name}
                          </Typography>
                        </Box>
                      </Stack>
                    </TableCell>
                    {/* {console.log('subservice in history====', item)} */}
                    <TableCell>
                      <Typography style={{ fontSize: 12 }}>{item?.email || '-'}</Typography>
                    </TableCell>

                    <TableCell>
                      <Typography style={{ fontSize: 12 }}>{item?.contact || '-'}</Typography>
                    </TableCell>

                    <TableCell>
                      <Typography style={{ fontSize: 12 }}>{item?.user?.name || '-'}</Typography>
                    </TableCell>

                    <TableCell>
                      <Typography style={{ fontSize: 12 }}>{item?.service?.name || '-'}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography style={{ fontSize: 12 }}>
                        {item?.sub_service?.name || '-'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography style={{ fontSize: 12 }}>
                        {moment(item?.updated_at).format('MMMM D YYYY, hh:mm') || '-'}
                      </Typography>
                    </TableCell>

                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Tracking">
                          <LoadingButton
                            size="small"
                            variant="contained"
                            style={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              padding: 0,
                              lineHeight: 1,
                              alignSelf: 'center'
                            }}
                            onClick={() =>
                              handleOpenTrackingModal(item?.id, item?.additional_info_checks)
                            }
                          >
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 16, color: '#ffffff' }}
                              icon="ic:outline-my-location"
                            />
                          </LoadingButton>
                        </Tooltip>

                        <Tooltip title="Messages">
                          <LoadingButton
                            size="small"
                            variant="contained"
                            style={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              padding: 0,
                              lineHeight: 1,
                              alignSelf: 'center'
                            }}
                            component={RouterLink}
                            to="/dashboard/history/historymessage"
                            state={{
                              customer_id: item?.id
                            }}
                          >
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 17, color: '#ffffff' }}
                              icon="ic:outline-message"
                            />
                          </LoadingButton>
                        </Tooltip>
                        <Tooltip title="Document">
                          <LoadingButton
                            size="small"
                            variant="contained"
                            // onClick={() => handleOpenDocumentList(item?.id)}
                            style={{
                              justifyContent: 'center',
                              width: 30,
                              height: 30,
                              minWidth: 30,
                              padding: 0,
                              lineHeight: 1,
                              alignSelf: 'center'
                            }}
                            // to="#"
                            component={RouterLink}
                            to="/dashboard/history/historydoc"
                            state={{
                              docid: item?.id
                              //   service_id: service_id,
                              //   sub_service_id: sub_service_id
                            }}
                          >
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 17, color: '#ffffff' }}
                              icon="heroicons-outline:document-add"
                            />
                          </LoadingButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}

            {/* loader */}
            {loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}

            {/* empty list */}
            {historyData?.length == 0 && !loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography variant="h6" gutterBottom color={'#f90001'}>
                        History not found!
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>

        {/* Pagination */}
        {!loading && pagesCount > 1 && historyData?.length !== 0 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 20,
              alignItems: 'center',
              marginBottom: 20
            }}
          >
            <Pagination
              color="primary"
              shape="rounded"
              page={page}
              size="small"
              count={pagesCount}
              onChange={handlePageChange}
              renderItem={(item) => <PaginationItem {...item} />}
            />
          </Box>
        )}

        <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
